export default class {
   constructor() {
      ymaps.ready(this.init);
   }

   init() {
      let myMap = new ymaps.Map("map", {
         center: [55.607763, 37.484981],
         zoom: 16,
         controls: ["zoomControl"]
      }),
         HintLayout = ymaps.templateLayoutFactory.createClass("<div class='map-hint'>Калужское шоссе, 4с6</div>", {
            getShape: function () {
               var el = this.getElement(),
                  result = null;
               if (el) {
                  var firstChild = el.firstChild;
                  result = new ymaps.shape.Rectangle(
                     new ymaps.geometry.pixel.Rectangle([
                        [0, 0],
                        [firstChild.offsetWidth, firstChild.offsetHeight]
                     ])
                  );
               }
               return result;
            }
         }
      );

      let myPlacemark = new ymaps.Placemark([55.607763, 37.484981], {
         hintContent: "г. Москва, ул. Калужское шоссе, 4, стр.6",
      }, {
         iconImageHref: '../images/base_content/map-point.svg',
         iconImageSize: [50, 60],
         iconImageOffset: [-18, -45],
         hintLayout: HintLayout
      });

      myMap.geoObjects.add(myPlacemark);

      myMap.behaviors.disable("scrollZoom");

      if (document.body.clientWidth < 992) {
         myMap.behaviors.disable("drag");
      }
   }
}